import React, { useState, useEffect, useCallback } from 'react';
import '../css/Toast.css';

// Simple global toast context
let _setToast = null;

export const showToast = (message, type = 'success', duration = 4000) => {
  if (_setToast) {
    _setToast({ message, type, id: Date.now(), duration });
  }
};

const ToastContainer = () => {
  const [toast, setToast] = useState(null);
  const [visible, setVisible] = useState(false);

  _setToast = setToast;

  const dismiss = useCallback(() => {
    setVisible(false);
    setTimeout(() => setToast(null), 350);
  }, []);

  useEffect(() => {
    if (toast) {
      setVisible(true);
      const timer = setTimeout(dismiss, toast.duration || 4000);
      return () => clearTimeout(timer);
    }
  }, [toast, dismiss]);

  if (!toast) return null;

  const icons = {
    success: 'fas fa-check-circle',
    error: 'fas fa-times-circle',
    warning: 'fas fa-exclamation-triangle',
    info: 'fas fa-info-circle',
  };

  return (
    <div
      className={`toast-fab ${toast.type} ${visible ? 'visible' : ''}`}
      role="alert"
      aria-live="polite"
    >
      <i className={`${icons[toast.type] || icons.info} toast-icon`}></i>
      <span className="toast-message">{toast.message}</span>
      <button
        className="toast-close"
        onClick={dismiss}
        aria-label="Dismiss notification"
      >
        <i className="fas fa-times"></i>
      </button>
    </div>
  );
};

export default ToastContainer;
